import { Link, NavLink, useLocation } from "react-router-dom";
import Styles from "./styles.module.scss";
import Logo from "../../assets/affinicar-logo.png";
import { useEffect, useState, ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";

export type Link = {
  label: string;
  badge?: string;
  badgeClassName?: string;
  to?: string;
  target?: string;
}
export type LinkSection = {
  label: string;
  links?: Link[];
}

function SectionLinks({ section }: { section: LinkSection }) {

  const [isExpanded, setIsExpanded] = useState(true);
  const linkSize = 40;

  return (
    <div className={Styles.sectionContainer} key={section.label}>
      <div className={Styles.sectionLabel} onClick={() => setIsExpanded(!isExpanded)}>
        <span className={Styles.sectionLabelText}>{section.label}</span>
      </div>
      {section.links?.length ? (
        <ul style={{width: '100%', height: isExpanded ? ((section.links.length) *linkSize) + 'px' : "0px"}}>
          {section.links.map((link) => (
            <li key={link.to}>
              <NavLink
                target={link.target}
                end className={({ isActive }) => {
                return [Styles.linkContainer, isActive ? Styles.linkContainerActive : ""].join(" ")
              }} to={link.to || "/"}>
                <FontAwesomeIcon className={Styles.linkIcon} icon={faComments} />
                <span className={Styles.linkLabel}>{link.label}</span>
                {!!link.badge && (
                  <span className={["badge bg-info", ...(link.badgeClassName ? [link.badgeClassName] : [])].join(" ")}>{link.badge}</span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      ) : (null)}
    </div>
  )

}

export default function Sidebar({
  linkSections = [],
  header,
  visible = false,
  size = "large",
  onPressCloseMenu = () => null
} : {
  linkSections: LinkSection[];
  header?: ReactNode;
  visible?: boolean;
  size?: "large" | "small";
  onPressCloseMenu?: () => any;
}) {

  const location = useLocation();

  useEffect(() => {
    onPressCloseMenu();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <>
      <div onClick={onPressCloseMenu} className={[Styles.backgroundOpaqueLayer, visible ? Styles.visible : ""].join(" ")} />

      <div className={[Styles.containerPlaceholder, size === "small" ? Styles.small : ""].join(" ")}></div>

      <div className={[Styles.container, size === "small" ? Styles.small : "", visible ? Styles.visible : ""].join(" ")}>
        <div className={Styles.logoContainer}>
          <img src={Logo} />
        </div>

        {header && <div>{header}</div>}

        <nav>
          {linkSections.length ? (
            linkSections.map((section) => (
              <SectionLinks key={section.label} section={section} />
            ))
          ) : null}
        </nav>
      </div>

    </>
  )
}